import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LangsRepository } from '../../services/langs.repository';
import { ILang } from '../../model/lang.interface';
import { NavController, Platform } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { AppService } from '../../services/app.service';
import { User } from '../../model/user.model';
import { Location } from '@angular/common';

@Component({
    selector: 'registration-page',
    templateUrl: 'registration.page.html',
    styleUrls: ['registration.page.scss', "../../app.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class RegistrationPage implements OnInit {
    public token = "";
    public langsReady = false;
    public step = 1;
    public busy = false;
    public step1Status = "";
    public step1Error = false;
    public step2Status = "";
    public step2Error = false;
    public firstName = "";
    public lastName = "";
    public firstNameError = "";
    public lastNameError = "";
    public phone = "";
    public email = "";
    public emailError = "";
    public phoneError = "";
    public passcodeError = "";
    public passcode = "";
    public iframeSrc = "";
    public showSendSms = false;
    public createdUser: any = null;
    public IsApp = false;
    public IsRtl = this.langsRepository.current.dir === "rtl";
    public innerWidth: any;
    public _httpError = "HTTP error";

    constructor(
        private readonly langsRepository: LangsRepository,
        private readonly navCtrl: NavController,
        private readonly route: ActivatedRoute,
        private readonly authService: AuthService,
        private readonly appService: AppService,
        private readonly location: Location,
        public platform: Platform
    ) {
        this.IsApp = this.platform.is("desktop");

        this.innerWidth = window.innerWidth;
        if (this.innerWidth > 1024) {
            this.IsApp = true;
        }
    }

    ngOnInit(): void {
        this.langsRepository.ready.subscribe(r => {
            this.langsReady = r;
        });

        this.route.params.subscribe(p => {
            this.token = p["token"];
            this.step = 1;
            this.step1Status = ""
            this.step1Error = false;
            this.step2Status = ""
            this.step2Error = false;
            this.emailError = "";
            this.phoneError = "";
            this.passcodeError = "";
            this.passcode = "";
            this.iframeSrc = "";
            this.showSendSms = false;
        });
    }

    get currentLang(): ILang { return this.langsRepository.current; }

    public back(): void {
        (this.step === 1) ? this.location.back() : this.toStep1();
    }

    public toStep1(): void {
        this.step = 1;
        this.step1Status = ""
        this.step1Error = false;
        this.step2Status = ""
        this.step2Error = false;
        this.emailError = "";
        this.phoneError = "";
        this.firstNameError = "";
        this.lastNameError = "";
        this.passcodeError = "";
        this.passcode = "";
        this.iframeSrc = "";
        this.showSendSms = false;
    }

    public toStep2(): void {
        this.email = this.email.trim();
        this.firstName = this.firstName.trim();
        this.lastName = this.lastName.trim();

        if (this.validateStep1()) {
            this.busy = true;
            this.authService.registrationProcess(this.token, this.phone, this.email, this.firstName, this.lastName).subscribe(res => {
                if (res.body.responseCode === 200) {
                    this.createdUser = res.body.data;
                    this.step1Status = "";
                    this.step1Error = false;
                    this.showSendSms = true;
                    this.step = 2;
                } else {
                    this.step1Status = res.body.error;
                    this.step1Error = true;
                }

                this.busy = false;
            }, err => {
                const message = this.appService.getErrorMessage(err);
                this.appService.showError(this._httpError, `${this.currentLang.words["http_error"]} in registration-page toStep2 registrationProcess: ${message}`, true);
                this.busy = false;
            });
        }
    }

    public validatePhone(): void {
        this.phone = this.phone.replace(/[^0-9]+/g, "");
    }

    public validateEmail(): boolean {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(this.email).toLowerCase());
    }

    public validateStep1(): boolean {
        let error = false;

        if (!this.firstName.length) {
            error = true;
            this.firstNameError = this.currentLang.words['enter-firstName'];
        } else {
            this.firstNameError = "";
        }

        if (!this.lastName.length) {
            error = true;
            this.lastNameError = this.currentLang.words['enter-lastName'];
        } else {
            this.lastNameError = "";
        }

        if (!this.email.length) {
            error = true;
            this.emailError = this.currentLang.words["enter-email"];
        } else if (!this.validateEmail()) {
            error = true;
            this.emailError = this.currentLang.words["correct-email"];
        } else {
            this.emailError = ""
        }

        if (!this.phone.length) {
            error = true;
            this.phoneError = this.currentLang.words["enter-phone"];
        }
        else if (this.phone.length !== 10) {
            error = true;
            this.phoneError = this.currentLang.words["enter-phone-validation-10-digits"]
        }
        else if (!this.phone.startsWith('05')) {
            error = true;
            this.phoneError = this.currentLang.words["enter-phone-validation-start"]
        } else {
            this.phoneError = ""
        }

        return !error;
    }

    public validateStep2(): boolean {
        let error = false;

        if (!this.passcode.length) {
            error = true;
            this.passcodeError = this.currentLang.words["enter-passcode"];
        } else {
            this.passcodeError = "";
        }

        return !error;
    }

    public resendSms(): void {
        this.passcode = this.passcode.trim();

        this.busy = true;

        if (this.createdUser) {
            this.authService.resendSmsForRegistration(this.token, this.createdUser.id).subscribe(res => {
                this.busy = false;
                if (res.body.responseCode === 200) {
                    this.appService.showNetworkstatus(this.currentLang.words["resend-message"]);
                }
                else {
                    this.step2Status = res.body.error;
                    this.step2Error = true;
                }
            }, err => {
                const message = this.appService.getErrorMessage(err);
                this.appService.showError(this._httpError, `${this.currentLang.words["http_error"]} in registration-page resendSms resendSmsForRegistration: ${message}`, true);
                this.busy = false;
            });
        }
    }

    public finish(): void {
        this.passcode = this.passcode.trim();

        if (this.validateStep2()) {
            this.busy = true;
            this.authService.registrationComplete(this.token, this.passcode, this.email, this.phone, this.firstName, this.lastName).subscribe(res => {
                if (res.body.responseCode === 200) {
                    var token: string | null = res.headers.get("X-CLIENT-TOKEN");
                    var user: User = res.body.data;

                    if (token && user) {
                        this.step2Status = "";
                        this.step2Error = false;
                        this.authService.saveAuthData({ token, user });
                        this.navCtrl.navigateForward("/leadClients");
                    } else {
                        this.step2Status = this.currentLang.words["token-not-found"];
                        this.step2Error = true;
                    }
                } else {
                    this.step2Status = res.body.error;
                    this.step2Error = true;
                }

                this.busy = false;
            }, err => {
                const message = this.appService.getErrorMessage(err);
                this.appService.showError(this._httpError, `${this.currentLang.words["http_error"]} in registration-page finish registrationComplete: ${message}`, true);
            });
        }
    }
}
